import * as React from 'react'
import { cn } from '@/lib/utils'

export interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 0-100. Values outside the range are clamped. */
  value: number
  /** Tailwind class for the filled portion. */
  indicatorClassName?: string
}

/**
 * Minimal determinate progress bar. Matches the hand-rolled bar that batch
 * badge printing already uses, so the app has one look for progress.
 */
const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value, indicatorClassName, ...props }, ref) => {
    const clamped = Math.max(0, Math.min(100, Math.round(value || 0)))
    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={clamped}
        className={cn('h-2 w-full overflow-hidden rounded-full bg-muted', className)}
        {...props}
      >
        <div
          className={cn(
            'h-full rounded-full bg-primary transition-all duration-300',
            indicatorClassName
          )}
          style={{ width: `${clamped}%` }}
        />
      </div>
    )
  }
)
Progress.displayName = 'Progress'

export { Progress }
